<template>
  <section id="Dashboard" class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">WELCOME, {{ user_profile.name.toUpperCase() }}</h1>
        <h2 class="subtitle">
          to WEALTH NAVI !
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Dashboard",
  computed: mapState(["user_profile"])
};
</script>
